<template>
  <div>
    <header-ton></header-ton>

    <div class="head-logo">
      <h1 class="logo-box">
        <a href="javascript:;" class="logo">结算中心</a>
        <ul class="process">
          <li class="this"><i class="number">1</i><i class="text">确认订单</i><b class="line"></b></li>
          <li><i class="number">2</i><i class="text">支付订单</i></li>
          <li><i class="number">3</i><i class="text">订单完成</i></li>
        </ul>
      </h1>
    </div>

    <div class="car-box">
      <div class="content1">
        <div class="content-box">
          <table width="100%" border="0" cellpadding="1">
            <tbody>
              <tr class="title-top">
                <td class="w2">商品信息</td>
                <td class="w3"></td>
                <td class="w5">金额/元</td>
              </tr>
            </tbody>
          </table>
          <table width="100%">
            <tbody>
              <tr>
                <td colspan="7">
                  <table border="0" cellpadding="1" class="table-on">
                    <tbody>
                      <tr class="par-shop no-line" data-ids="1294">
                        <td class="w2">
                          <a href="javascript:;">
                            <img :src="infoData.thumb" width="110" class="w2_img">
                          </a>
                          <div class="course">
                            <a href="javascript:;" class="title">{{infoData.title}}</a>
                            <em>{{ infoData.attr_name }}</em>
                          </div>
                        </td>
                        <td class="w3 jiaoc" width="107"></td>
                        <td class="w5">
                          <font class="red f-f14">￥{{infoData.amount}}</font>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="order-box" style="margin-top: 10px">
          <!-- 结算部分 开始 -->
          <div class="pay_address_box">
            <div class="pay_address_left" id="user-addresslist">
              <div class="address_left_cont">
                <div class="address_contHd">
                  <span class="address_ico"></span>
                  <p class="address_tit">收货地址</p>
                  <p class="address_tip" id="addr-count">
                    已添加<span>{{jsonAddr.length}}</span>条收货地址
                    ，还能添加 {{3-jsonAddr.length}} 条 </p>
                </div>
                <div class="address_infoMain" id="addr-list">
                  <div @click="changeAddr(item.id)" :class="address_id == item.id ?'address_infoBox address_mrdz bg':'address_infoBox'" v-for="(item,index) in jsonAddr" :key="index">
                    <div class="address_infoCont">
                      <p class="info_userName">{{item.truename}}</p>
                      <p class="info_phoneNum">{{item.phone}}</p>
                      <p class="info_addressOne">
                        <span>{{item.province_name}}</span><span>{{item.city_name}}</span><span>{{item.area_name}}</span>
                      </p>
                      <p class="info_addressTwo">{{item.address}}</p>
                      <p class="info_xgsc_btn" @click="editAddres(item.id)">
                        <a href="javascript:;" class="xiug_btn btn-edit-addr">修改</a>
                      </p>
                      <span class="dz_tip mrdz" v-if="item.is_default == 1">默认地址</span>
                      <span class="modg_ico"></span>
                    </div>
                  </div>
                  <div class="add_newAddress" @click="dialogFormVisible = true" id="btn-add-addr" style="display: block;">
                    <span class="add_ico"></span>
                    <p class="add_wz">添加新地址</p>
                  </div>
                </div>
                <p class="kuaid_tip">云仓发货，暂不支持指定快递公司。</p>
              </div>
            </div>
            <div class="pay_address_right">
              <ul class="course_infoBox" id="shop-price-mxi">
                <li class="clearfix"><span class="course_infoL">商品金额：</span><span class="course_infoR">￥{{infoData.money}}</span></li>
                <li class="clearfix"><span class="course_infoL">优惠金额：</span>
                  <span class="course_infoR" id="youhui">￥{{Number(infoData.money-infoData.amount).toFixed(2)}}</span>
                </li>
              </ul>
              <div class="course_final_price" id="o_pay_money" data-val="1310.0000" data-jia="0.00">
                <div class="clearfix">
                  <span class="course_infoL">应付总额：</span>
                  <span class="course_infoR">￥{{infoData.amount}}</span>
                </div>
              </div>
              <div class="course_purBtn clearfix">
                <input id="shopingNum" value="1" type="hidden">
                <a href="javascript:void(0);" id="shop_pay" @click="goConfirm()" class="">去结算</a>
              </div>
            </div>
          </div>
          <!-- 结算部分 结束 -->
        </div>
      </div>
      <br>
    </div>

    <el-dialog title="添加科目" width="32%" :visible.sync="dialogFormVisible">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm">
        <el-form-item label="请输入姓名：" :label-width="formLabelWidth" prop="truename">
          <el-input v-model="ruleForm.truename" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="请输入手机号：" :label-width="formLabelWidth" prop="phone">
          <el-input v-model="ruleForm.phone" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="请选择地区：" :label-width="formLabelWidth" prop="area_ids">
          <el-cascader style="width: 100%;" :props="{label: 'name','value':'id'}" v-model="ruleForm.area_ids" :options="jsonArea"></el-cascader>
        </el-form-item>
        <el-form-item label="请输入地址：" :label-width="formLabelWidth" prop="address">
          <el-input v-model="ruleForm.address" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="是否默认：" :label-width="formLabelWidth">
          <el-switch v-model="ruleForm.is_default" :active-value="1" :inactive-value="0"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')">确 定</el-button>
      </div>
    </el-dialog>

    <booter-ton></booter-ton>
  </div>
</template>
<script>
import HeaderTon from "@/components/HeaderTon";
import BooterTon from "@/components/BooterTon";
export default {
  components: {
    HeaderTon,
    BooterTon,
  },
  data() {
    return {
      dialogFormVisible: false,
      fullscreenLoading: true,
      good_id: 0,
      address_id: 0,
      attrs: 0,
      infoData: [],
      jsonAddr: [],
      address: [],
      jsonArea: [],
      ruleForm: {
        truename: "",
        phone: "",
        area_ids: "",
        address: "",
        is_default: 0,
      },
      rules: {
        truename: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入手机号", trigger: "blur" }],
        area_ids: [
          { required: true, message: "请选择省份", trigger: "change" },
        ],
        address: [{ required: true, message: "请输入地址", trigger: "blur" }],
      },
      formLabelWidth: "140px",
    };
  },
  mounted() {
    var that = this;
    var query = that.$route.query;
    if (query.good_id) {
      that.good_id = query.good_id;
      that.attrs = query.attrs;
      that.getDetail();
    }
    this.getArea();
  },
  methods: {
    changeAddr(ids) {
      console.log(ids);
      this.address_id = ids;
    },

    editAddres(ids) {
      let that = this;
      that.axios
        .post("/getedit", {
          id: ids,
        })
        .then((res) => {
          if (res) {
            that.ruleForm = res.data;
            that.dialogFormVisible = true;
          }
        });
    },

    submitForm(formName) {
      const that = this;
      that.$refs[formName].validate((valid) => {
        if (!valid) return that.$message.warning("请完整填写内容!");
        var formData = {};
        formData = that.ruleForm;
        formData.column_id = that.column_id;
        var url = "/beforeSave";
        if (that.id) {
          formData.id = that.id;
        }
        that.axios.post(url, formData).then(() => {
          that.$message.success(that.id ? "修改成功" : "添加成功");
          that.dialogFormVisible = false;
          that.ruleForm.truename = "";
          that.ruleForm.phone = "";
          that.ruleForm.area_ids = "";
          that.ruleForm.address = "";
          that.ruleForm.is_default = 0;
          that.getDetail();
        });
      });
    },

    getArea() {
      let that = this;
      that.axios.post("/getArea").then((res) => {
        if (res) {
          that.jsonArea = res.data;
        }
      });
    },

    getDetail() {
      let that = this;
      let formData = {};
      formData.id = that.good_id;
      formData.attrs = that.attrs;
      that.axios.post("/getBuyGoods", formData).then((res) => {
        if (res) {
          that.infoData = res.data.course;
          that.jsonAddr = res.data.jsonAddr;
          that.address = res.data.address;
          that.address_id = res.data.address.id;
        }
      });
    },

    goConfirm() {
      let that = this;
      if (this.address_id == 0 || this.address_id == "") {
        that.$message.error("请选择收货地址！");
        return false;
      }
      let formData = {};
      formData.good_id = that.good_id;
      formData.attrs = that.attrs;
      formData.address_id = that.address_id;
      that.axios.post("/setPcOrders", formData).then((res) => {
        if (res) {
          that.$router.push({
            path: "/payment/confirm",
            query: {
              idNo: res.data,
            },
          });
        }
      });
    },

    goDetail(ids) {
      this.$router.push({
        path: "/web/shop_detail",
        query: {
          good_id: ids,
        },
      });
    },
  },
};
</script>
<style>
@import "../../../public/css/gouwuche.css";
</style>